<template>
  <div v-if="isOpen" class="banner">
    <div class="flex items-center justify-center content-max-width">
      <div class="tag">
        {{ tag }}
      </div>

      <p>{{ text }}</p>

      <a :href="link" v-show="link">{{ linktext }}</a>

      <span class="cursor-pointer material-symbols-outlined close" @click="close">
        close
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tag: String,
    text: String,
    link: String,
    linktext: String
  },
  data () {
    return {
      isOpen: !sessionStorage.getItem('closed-banner'),
    }
  },

  methods: {
    close () {
      this.isOpen = false
      sessionStorage.setItem('closed-banner', true)
    },
  },
}
</script>

<style>

</style>
